//引入api接口
import { fun_PostAction } from "@/api/index";
// 引入抽屉详情组件
import ProcessTaskDrawer from "../../openBidProject/details/processTaskDrawer/index.vue";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      /*************************项目信息***************************/
      tenderMakeId: null, // 标书文件制作表主键
      envelope: null, // 信封标志
      // 列表loading状态
      loading: false,
      // 项目信息
      projectInfo: {
        projectName: null, // 项目名称
        projectId: null, // 项目编号
        sectionName: null, // 标段名称
        processStateName: null, // 流程状态名称
        tenderName: null, // 招标人
        tenderAgentOrgan: null, // 招标代理
        typeName: null, // 评标办法
        bidEndDate: null, // 开标时间
      },

      /*************************流程信息**************************/
      // 列表loading状态
      pocessTaskTableColumns: [
        {
          label: "参与人类型",
          prop: "userTypeName"
        },
        {
          label: "单位名称",
          prop: "peopleName"
        },
        {
          label: "节点名称",
          prop: "nodeName"
        },
      ],
      pocessTaskTableData: [],
      // 详情表头按钮组
      pocessTaskBtnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      pocessTaskReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      pocessTaskTotal: 0, // 总条数
      pocessTaskMultipleSelection: [], // 流程信息勾选
    };
  },
  // 注册组件
  components: {
    // 抽屉详情组件
    ProcessTaskDrawer
  },
  mounted() {
    // 信封标志
    this.envelope = this.$route.query.envelope;
    // 标书文件制作表主键
    this.tenderMakeId = this.$route.query.tenderMakeId;
    // 获取项目信息
    this.fun_GetProjectInfo();
    // 获取流程信息
    this.fun_GetOpenProcessTaskList();

  },
  // 自定义事件
  methods: {
    /***********************************项目信息**************************************/
    /**
     * 获取项目信息
     */
    fun_GetProjectInfo() {
      // 请求
      fun_PostAction("/openBidProject/detail", {
        id: this.tenderMakeId,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 项目名称
          this.projectInfo.projectName = data.projectName;
          // 项目编号
          this.projectInfo.projectId = data.projectId;
          // 标段名称
          this.projectInfo.sectionName = data.sectionName;
          // 流程状态
          this.projectInfo.processStateName = data.processStateName;
          // 招标人
          this.projectInfo.tenderName = data.tenderName;
          // 招标代理机构
          this.projectInfo.tenderAgentOrgan = data.tenderAgentOrgan;
          // 评标办法
          this.projectInfo.typeName = data.typeName;
          // 区管名称
          this.projectInfo.regulators = data.regulators;
          // 开标时间
          this.projectInfo.bidEndDate = data.bidEndDate;

        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取专家抽取信息
     */
    fun_GetOpenProcessTaskList() {
      // 打开loading
      this.loading = true;
      // 执行获取列表接口
      fun_PostAction("openBidProject/openProcessTaskList", {
        ...this.pocessTaskReqPageData,
        makeId: this.tenderMakeId,
        envelope: this.envelope,
        searchFlag: '0', // 验证开标时间
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.pocessTaskTableData = data.records;
          // 展示分页总条数
          this.pocessTaskTotal = data.total;
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 数据字典改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_PocessTaskLimitChange(e) {
      // 获取每页显示条数
      this.pocessTaskReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetOpenProcessTaskList();
    },
    /**
     * 数据字典改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PocessTaskPageChange(e) {
      // 获取当前页码
      this.pocessTaskReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetOpenProcessTaskList();
    },
    /**
     * 流程信息列表勾选方法
     * @param {e} 勾选的数组
     * @author shuhua
     */
    fun_PocessTaskHandleSelectionChange(e) {
      //赋值
      this.pocessTaskMultipleSelection = e;
    },
    /**
     * 流程信息按钮
     */
    fun_PocessTaskClick(e) {
      switch (e) {
        case "添加":
          // 调用修改方法
          this.fun_Add();
          break;
        case "修改":
          // 调用修改方法
          this.fun_Edit();
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    },
    /**
     * 添加企业流程
     */
    fun_Add(){
      this.$refs.processTaskDrawer.drawerStatus = true; // 打开抽屉
      this.$refs.processTaskDrawer.makeId = this.tenderMakeId; // 文件制作主键
      this.$refs.processTaskDrawer.envelope = this.envelope;// 信封标志
      this.$refs.processTaskDrawer.type = "add";// 操作类型
    },
    /**
     * 修改企业流程
     */
    fun_Edit(){
      // 判断是否勾选
      if (this.pocessTaskMultipleSelection && this.pocessTaskMultipleSelection.length > 0 ) {
        // 勾选超过1条
        if (this.pocessTaskMultipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }
        // 只勾选一条
        else{
          this.$refs.processTaskDrawer.drawerStatus = true; // 打开抽屉
          this.$refs.processTaskDrawer.makeId = this.tenderMakeId; // 文件制作主键
          this.$refs.processTaskDrawer.envelope = this.envelope;// 信封标志
          this.$refs.processTaskDrawer.type = "edit";// 操作类型
          this.$refs.processTaskDrawer.userId = this.pocessTaskMultipleSelection[0].userId; // 用户编号
          this.$refs.processTaskDrawer.processNodeId = this.pocessTaskMultipleSelection[0].processNodeId; // 流程节点编号
        }
      }
    },
    /**
     * 删除企业流程
     */
    fun_Del(){
      // 判断是否勾选
      if (this.pocessTaskMultipleSelection && this.pocessTaskMultipleSelection.length > 0 ) {
        // 勾选超过1条
        if (this.pocessTaskMultipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }
        // 只勾选一条
        else{
          // 弹出询问confirm
          this.$confirm("是否删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 执行获取列表接口
            fun_PostAction("openBidProject/delProcessTask", {
              makeId: this.tenderMakeId,
              userId: this.pocessTaskMultipleSelection[0].userId,
            }).then(res => {
              // 解构res.data
              const { result, data, msg } = res.data;
              // 解析后台返回的结果集，判断是否成功
              if (result) {
                // 获取一览表格数据
                this.fun_GetOpenProcessTaskList();
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            });
          });
        }
      }
    },
    /**
     * 返回
     * @author 滕威
     */
    fun_Back() {
      this.$router.back();
    }
  }
};
